import getTransformedPoint from "./get-transformed-point";

/**
 *
 * @param {PropertyPureProps} value
 * @param {SVGOffsetProps} offset
 * @param {BoundsProps} bounds
 * @param {SVGGeometryElement} path
 * @param {Number} progress
 */
const setPointX = (value, offset, bounds, path, progress) => {
  const matrix = /** @type {DOMMatrix} */ (offset.matrix);
  const length = value.get("v_value");
  const pathPoint = path.getPointAtLength(progress * length);

  offset.computed = getTransformedPoint(matrix, pathPoint.x, pathPoint.y);

  const computed = offset.computed;
  const width = /** @type {Number} */ (bounds?.get("width"));
  value.set("v_output", `${computed.x - width / 2}px`);
}

export default setPointX;